<template>
  <div class="kefu-container">
    <!-- Header -->
    <!-- Assuming header is handled by the parent layout -->
    <!-- <div class="header">我的客服</div> -->

    <!-- User Info Section -->
    <div class="user-info-section" v-if="$store.state.token">
      <img src="/static/image/default_user.png" alt="avatar" class="avatar-icon" />
      <div class="greeting">
        <h2>Hi,</h2>
        <p>欢迎来到客服中心</p>
      </div>
    </div>
    <div class="user-info-section" v-else>
      <img src="/static/image/default_user.png" alt="avatar" class="avatar-icon" />
      <div class="greeting">
        <h2>Hi,</h2>
        <p>欢迎来到客服中心</p>
        <p style="font-size: 12px; color: #999;">登录后可使用更多功能</p>
      </div>
    </div>

    <!-- Service Options -->
    <div class="service-options">
      <div class="service-card" @click="openOnlineService">
        <div class="service-text">
          <h3>在线客服</h3>
          <span>Customer Services</span>
        </div>
        <img src="/static/image/msg.png" alt="chat" class="chat-icon" />
      </div>
      <div class="service-card" @click="openFinancialService">
        <div class="service-text">
          <h3>飞机客服</h3>
          <span>Telegram Support</span>
        </div>
        <img src="/static/image/msg.png" alt="chat" class="chat-icon" />
      </div>
    </div>

    <!-- Deposit Orders Section - 仅登录用户可见 -->
    <div class="deposit-section" v-if="$store.state.token">
      <div class="deposit-header">
        <h3>存款订单</h3>
        <a @click="viewAllDeposits" class="view-all-link">查看全部 <van-icon name="arrow" /></a>
      </div>
      <!-- Deposit List -->
      <div v-if="loadingDeposits" class="loading-placeholder">
        加载存款记录中...
      </div>
      <div v-else-if="depositRecords.length > 0" class="deposit-list">
        <div v-for="record in depositRecords" :key="record.out_trade_no" class="deposit-item">
          <div class="item-left">
            <div class="detail-row">订单号: {{ record.out_trade_no }}</div>
            <div class="detail-row">金额: {{ record.amount }}</div>
            <div class="detail-row date">{{ record.created_at }}</div>
          </div>
          <div class="item-right">
            <div class="pay-way">{{ record.pay_way }}</div>
            <div :class="['status', getStatusClass(record.state)]">{{ getDepositStatusText(record.state) }}</div>
          </div>
        </div>
      </div>
      <div v-else class="no-records">
        <p>暂无存款记录</p>
      </div>
    </div>

  </div>
</template>

<script>
// It's likely the parent component handles the actual service opening.
// We call a method on the parent, assuming it exists.
// If specific URLs are needed per type, the parent method should handle that.

export default {
  name: 'kefu',
  data() {
    return {
      depositRecords: [], // Array to hold deposit records
      loadingDeposits: false, // Loading state indicator
      onlineServiceUrl: null, // URL for online customer service
      financialServiceUrl: null, // URL for financial customer service
    };
  },
  created() {
    // 只有登录用户才获取存款记录
    if (this.$store.state.token) {
      this.fetchRecentDeposits();
    }
    // 所有用户都获取客服链接
    this.fetchServiceUrl();
  },
  methods: {
    async fetchServiceUrl() {
      try {
        const res = await this.$apiFun.post('/api/getservicerurl', {});
        if (res.code === 200 && res.data) {
          this.onlineServiceUrl = res.data.kf_url || null;
          this.financialServiceUrl = res.data.cwkf_url || null;
          console.log("Fetched service URLs:", { online: this.onlineServiceUrl, financial: this.financialServiceUrl });
        } else {
          console.error("Failed to fetch service URLs:", res.message || 'URLs not found in response');
          if (this.$parent && typeof this.$parent.showTost === 'function') {
            this.$parent.showTost(0, res.message || '获取客服链接失败');
          }
        }
      } catch (error) {
        console.error("Error fetching service URLs:", error);
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '获取客服链接时出错');
        }
      }
    },
    async fetchRecentDeposits() {
      if (!this.$store.state.token) return;
      
      this.loadingDeposits = true;
      try {
        const res = await this.$apiFun.post('/api/gettransrecord', { type: 1, pagesize: 3 });
        if (res.code === 200 && res.data && Array.isArray(res.data.data)) {
          this.depositRecords = res.data.data;
          console.log("Fetched deposit records:", this.depositRecords);
        } else {
          console.error("Failed to fetch deposit records:", res.message || 'Unknown error');
          this.depositRecords = [];
          if (this.$parent && typeof this.$parent.showTost === 'function') {
            this.$parent.showTost(0, res.message || '获取存款记录失败');
          }
        }
      } catch (error) {
        console.error("Error fetching deposit records:", error);
        this.depositRecords = [];
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '获取存款记录时出错');
        }
      } finally {
        this.loadingDeposits = false;
      }
    },
    getDepositStatusText(state) {
      // Map state code to display text, aligned with transRecord.vue stateType12
      switch (state) {
        case 1: return '待审核';
        case 2: return '审核通过'; // Consistent text
        case 3: return '审核拒绝'; // Consistent text
        case 4: return '付款超时'; // Consistent text
        // Add case 0 if it exists in your data, otherwise default
        // case 0: return '未定义'; // Example if 0 is possible
        default: return '未知状态 (' + state + ')'; // Show state code if unknown
      }
    },
    getStatusClass(state) {
       // Add CSS class based on status for potential styling, aligned with new mapping
       switch (state) {
        case 1: return 'status-pending'; // 1 is now Pending
        case 2: return 'status-success'; // 2 is now Success
        case 3: return 'status-failed';  // 3 is now Failed/Rejected
        // case 0: return 'status-unknown';
        default: return 'status-unknown';
      }
    },
    openOnlineService() {
      if (this.onlineServiceUrl) {
        console.log("Opening online service in new window:", this.onlineServiceUrl);
        window.open(this.onlineServiceUrl, '_blank');
      } else {
        console.error("Online Service URL not available.");
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '在线客服链接不可用，请稍后重试');
        }
      }
    },
    openFinancialService() {
      if (this.financialServiceUrl) {
        console.log("Opening financial service in new window:", this.financialServiceUrl);
        window.open(this.financialServiceUrl, '_blank');
      } else {
        console.error("Financial Service URL not available.");
        if (this.$parent && typeof this.$parent.showTost === 'function') {
          this.$parent.showTost(0, '飞机客服链接不可用，请稍后重试');
        }
      }
    },
    viewAllDeposits() {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        this.$parent.goNav('/login');
        return;
      }
      
      if (this.$parent && typeof this.$parent.goNav === 'function') {
        console.log("Navigating to transaction records (/transRecord)...");
        this.$parent.goNav('/transRecord');
      } else {
        console.error("Parent component or goNav method not found.");
        this.$parent.showTost(0, '无法查看交易记录');
      }
    }
  },
  mounted() {
    // Removed iframe related logic
  },
  updated() {
     // Removed iframe related logic
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.kefu-container {
  background-color: #f8f6f5; // Approximate background color from image
  min-height: calc(100vh - 50px); // Adjust based on actual header/footer height
  padding: 15px;
  color: #333;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; // Example font stack
}

// Optional Header Styling (if not handled by parent)
.header {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 0;
  color: #333; // Adjust color
  margin-bottom: 15px;
}

.user-info-section {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 15px;
  background-color: #fff; // White background for this section
  border-radius: 10px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.avatar-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 15px;
  background-color: #e0e0e0; // Placeholder color for avatar
  object-fit: cover; // In case a real image is used
}

.greeting h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 5px 0;
  color: #333;
}

.greeting p {
  font-size: 14px;
  color: #888;
  margin: 0;
}

.service-options {
  display: flex;
  justify-content: space-between;
  gap: 15px; // Space between cards
  margin-bottom: 30px;
}

.service-card {
  flex: 1; // Each card takes equal space
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e9e2dc; // Card background color from image
  border-radius: 10px;
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
     background-color: #dcd5cf; // Slightly darker on hover
  }
}

.service-text h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #5c524c; // Text color from image
}

.service-text span {
  font-size: 12px;
  color: #8e857e; // Subtext color
}

.chat-icon {
  width: 30px;
  height: 30px;
  opacity: 0.7; // Adjust icon opacity if needed
}

.deposit-section {
   background-color: #fff; // White background for this section
   border-radius: 10px;
   padding: 15px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.deposit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; // Reduced margin
  padding-bottom: 10px;
  border-bottom: 1px solid #eee; // Separator line
}

.deposit-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #c5b8aa; // Title color from image
   position: relative;

   // Underline effect
   &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -11px; // Position underline below the border
      width: 40px;  // Width of the underline
      height: 3px;
      background-color: #c5b8aa; // Underline color
      border-radius: 1.5px;
   }
}

.view-all-link {
  font-size: 14px;
  color: #888;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;

  .van-icon {
    margin-left: 4px;
    font-size: 12px;
  }
}

.loading-placeholder,
.no-records {
  text-align: center;
  padding: 20px 0; // Adjusted padding
  color: #aaa;
  font-size: 14px;
}

.deposit-list {
  padding-top: 10px; // Add some space above the list
}

.deposit-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0; // Padding top and bottom for each item
  border-bottom: 1px solid #f5f5f5; // Lighter separator between items
  font-size: 13px; // Adjust base font size

  &:last-child {
    border-bottom: none; // Remove border for the last item
  }
}

.item-left {
  flex-grow: 1; // Allow left side to take available space
  color: #666; // Default text color for left side
  .detail-row {
    margin-bottom: 4px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .date {
     color: #999; // Lighter color for date
     font-size: 12px;
  }
}

.item-right {
  display: flex;
  flex-direction: column; // Stack pay-way and status vertically
  align-items: flex-end; // Align text to the right
  min-width: 80px; // Ensure minimum width for right content
  text-align: right;

  .pay-way {
    color: #555;
    font-weight: 500;
    margin-bottom: 4px;
  }

  .status {
    font-weight: 500;
  }

  // Status specific colors (adjust as needed)
  .status-pending {
    color: #faab0c; // Orange for pending
  }
  .status-success {
    color: #52c41a; // Green for success
  }
  .status-failed,
  .status-cancelled {
    color: #ff4d4f; // Red for failed/cancelled
  }
   .status-unknown {
    color: #999; // Grey for unknown
  }
}

// Add placeholder images if the real ones aren't available yet
// You might need to create these images or find suitable ones
// Example: /static/image/default-avatar.png, /static/image/chat-icon.png
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue